module.exports = __webpack_public_path__ + "static/media/events.fb0fe954.svg";